export function getCsrfToken() {
  const token: HTMLElement | null = document.querySelector(
    "meta[name=csrf-token]",
  );
  if (token instanceof HTMLMetaElement) {
    return token.content as string;
  }
  return null;
}
